import { Component } from '@angular/core';
import { IFAQLibrary } from '@suvo-bi-lib';

@Component({
  standalone: false,
  selector: 'app-faqs-screen',
  templateUrl: './faqs-screen.component.html',
  styleUrls: ['./faqs-screen.component.scss'],
})
export class FaqsScreenComponent {
  faqLibrary: IFAQLibrary = {
    categories: [
      {
        name: 'General',
        items: [
          {
            question: 'What type of information can I view?',
            answer:
              'IRJ Pro data services are designed to enable the user to find relevant market intelligence quickly and easily with clear design and intuitive search functions. From the latest tenders to rolling stock orders and infrastructure investment, IRJ Pro tracks a wide range of parameters to give you a different perspective on a dynamic market. To experience our range of services, register now for a free trial.',
          },
          {
            question:
              'What is the difference between Fleet Monitor, Projects Monitor and Global Rail Tenders?',
            answer:
              '<p>Fleet Monitor is a comprehensive index of all known current locomotive and passenger rolling stock orders worldwide, listing parameters including operator, owner, supplier, quantities, delivery schedules, and order values (where available). We are currently listing over 2000 live orders.</p><p>Project Monitor gathers details of all known new-build and major upgrading railway projects around the globe, offering a unique perspective on infrastructure investment at local, national, regional, and global levels. We are currently tracking nearly 4000 live projects, monitoring parameters including project status, length, number of stations, cost and funding (where available), and implementation timescales.</p><p>Global Rail Tenders enables you to search current railway tenders worldwide. Real-time data ensures you have the information the moment a tender is published. Due to the lifespan of tenders, the number can easily change. There are over 5,300 tenders currently listed.</p>',
          },
          {
            question: 'How can I get full access to each service?',
            answer:
              'To obtain full access to our extensive records, please click here and select which service(s) you require.',
          },
          {
            question: 'How do I subscribe to the IRJ Magazine?',
            answer:
              "IRJ was launched in 1960 as the world’s first globally-distributed magazine for the railway industry. The monthly magazine and website are written by a dedicated team of editors and more than 20 correspondents around the world with contributions from across all sectors of the railway industry. To subscribe, please click <a target='_blank' href='https://www.railjournal.com/subscribe/'>here</a>.",
          },
        ],
      },
      {
        name: 'Technical',
        items: [
          {
            question: 'I have forgotten my password, how can I reset it?',
            answer:
              "No problem, please click <a href='./identity?forgotPassword=true'>here to reset your password</a>. We will then send you an email to verify your updated password.",
          },
          {
            question: 'Why can I only access around 500 projects and fleets?',
            answer:
              "The free trial is an opportunity for you to explore our products and how they might benefit your business. For full access to our services, please click <a href='./register'/>here</a>",
          },
          {
            question: 'Is training support available?',
            answer:
              "We are here to assist you throughout the duration of your subscription with tutorials and technical support to ensure you get the most out of our services. For technical assistance please <a target='_blank' href='mailto:jchalon@sbpub.com'>contact us</a>.",
          },
        ],
      },
      {
        name: 'Payment',
        items: [
          {
            question: 'My company requires multiple subscriptions. How do I organise this?',
            answer:
              "If you require multiple subscriptions, please <a target='_blank' href='mailto:jchalon@sbpub.com'>contact us</a> to discuss your company's requirements.",
          },
          {
            question: 'Do you offer a discount for multiple subscriptions?',
            answer:
              'Yes we do. Whatever the size of your organisation, IRJ Pro has a subscription structure to meet your requirements.',
          },
          {
            question: 'What payment methods do you accept?',
            answer:
              '<p>We accept card payments VISA, MASTERCARD, AMERICAN EXPRESS and commonly accepted payment cards.</p><p>You can also pay by invoice (full payment required before access is activated).</p>',
          },
        ],
      },
    ],
  };
}
